export default {
	vipBenefits: {
		salaryTitle: 'เงินเดือน VIP',
		benefitsTitle: 'สิทธิประโยชน์',
		yourVipProgress: 'ความคืบหน้า VIP ของคุณ',
		progressToVip: '{percent}% ถึง VIP {level}',
		vipMax: 'ถึงระดับสูงสุดแล้ว',
		vipLevelBenefits: 'ระดับ VIP และสิทธิประโยชน์',
		betXpRule: 'เดิมพัน {amount} = {xp}EXP',
		btnReceive: 'รับ',
		btnJoinIn: 'เข้าร่วม',
		btnReceived: 'รับแล้ว',
		btnExpired: 'หมดอายุ',
		btnNotSettled: 'ยังไม่ชำระ',
		btnComingSoon: 'เร็วๆ นี้',
		btnViewMore: 'ดูเพิ่มเติม',
		btnContactNow: 'ติดต่อเลย',
		guestTitleLevelup: 'โบนัสเลื่อนระดับ',
		guestTitleDaily: 'เงินเดือนรายวัน',
		guestTitleWeekly: 'เงินเดือนรายสัปดาห์',
		guestTitleMonthly: 'เงินเดือนรายเดือน',
		guestTitleCashback: 'เงินคืน',
		guestTitleRescue: 'โบนัสช่วยเหลือ',
		guestTitleEvents: 'กิจกรรม VIP',
		guestTitleSupport: 'ฝ่ายสนับสนุน VIP',
		guestDescLevelup: 'รับโบนัสครั้งเดียวทุกครั้งที่คุณเลื่อนระดับ VIP ใหม่',
		guestDescDaily: 'รับรางวัลเงินเดือนรายวันเมื่อระดับ VIP ของคุณสูงขึ้น',
		guestDescWeekly: 'รับรางวัลเงินเดือนรายสัปดาห์เมื่อระดับ VIP ของคุณสูงขึ้น',
		guestDescMonthly: 'รับรางวัลเงินเดือนรายเดือนเมื่อระดับ VIP ของคุณสูงขึ้น',
		guestDescCashback: 'รับเงินคืนจากการใช้จ่ายในเกมของคุณ',
		guestDescRescue: 'รับโบนัสช่วยเหลือเพื่อช่วยให้คุณกลับมาได้',
		guestDescEvents: 'ระดับ VIP ที่สูงขึ้นปลดล็อกรางวัลกิจกรรมพิเศษมากขึ้น',
		guestDescSupport: 'ฝ่ายสนับสนุน VIP โดยเฉพาะเพื่อความช่วยเหลือที่รวดเร็วขึ้น',
		comingSoonHint: 'สิทธิประโยชน์กำลังจะมา โปรดติดตาม',
		receiveSuccess: 'รับรางวัลสำเร็จ',
		receiveFailed: 'รับรางวัลไม่สำเร็จ',
		typeUpgrade: 'โบนัสเลื่อนระดับ',
		typeDailySalary: 'เงินเดือนรายวัน',
		typeWeeklySalary: 'เงินเดือนรายสัปดาห์',
		typeMonthlySalary: 'เงินเดือนรายเดือน',
		typeRebate: 'เงินคืน',
		typeRescue: 'โบนัสช่วยเหลือ',
		typeVipActivity: 'กิจกรรม VIP',
		typeVipService: 'ฝ่ายสนับสนุน VIP',
		tooltipRecharge: 'เติมเงิน {current}/{target}',
		tooltipBets: 'เดิมพัน {current}/{target}',
		progressRecharge: 'เติมเงิน',
		progressBets: 'เดิมพัน',
		descUpgradeBonus: 'โบนัสอัปเกรด VIP{level} ×{count}',
		descDailySalary: 'เงินเดือนรายวัน VIP{level} ×{count}',
		descWeeklySalary: 'เงินเดือนรายสัปดาห์ VIP{level} ×{count}',
		descMonthlySalary: 'เงินเดือนรายเดือน VIP{level} ×{count}',
		descUpgradeBonusPlain: 'โบนัสอัปเกรด VIP{level}',
		descDailySalaryPlain: 'เงินเดือนรายวัน VIP{level}',
		descWeeklySalaryPlain: 'เงินเดือนรายสัปดาห์ VIP{level}',
		descMonthlySalaryPlain: 'เงินเดือนรายเดือน VIP{level}',
		descRebate: 'เงินคืนเกม VIP{level}',
		descRescue: 'โบนัสช่วยเหลือ VIP{level}',
		descVipActivity: 'ระดับ VIP ที่สูงขึ้นปลดล็อกรางวัลกิจกรรมพิเศษมากขึ้น',
		descVipService: 'ฝ่ายสนับสนุน VIP โดยเฉพาะเพื่อความช่วยเหลือที่รวดเร็วขึ้น',
		allBenefits: 'สิทธิประโยชน์ทั้งหมด',
		vipClubTitle: 'VIP Club',
		more: 'เพิ่มเติม',
		moreDesc: 'ดูรายละเอียดเพิ่มเติมได้ที่โปรโมชั่นของเรา',
		promotions: 'โปรโมชั่น',
		highlightsTitle: '8 จุดเด่นของสิทธิพิเศษ',
		highlightSupport: 'บริการ VIP พิเศษ',
		highlightLevelup: 'โบนัสเลื่อนระดับ',
		highlightSalary: 'เงินเดือน VIP',
		highlightRescue: 'โบนัสช่วยเหลือ VIP',
		highlightGifts: 'ของขวัญ\nพิเศษ VIP',
		highlightEvents: 'กิจกรรม VIP',
		highlightService: 'บริการ\nVIP เฉพาะ',
		highlightWallet: 'กระเป๋า\nเครดิต VIP',
		currentLevel: 'ระดับปัจจุบัน',
		keepPlayingReach: 'เล่นต่อไปเพื่อไปถึง',
		higherLevelRewards: 'ยิ่งระดับสูง รางวัลยิ่งมากขึ้น',
		levelUpUnlock: 'อัปเลเวลเพื่อปลดล็อกสิทธิประโยชน์พิเศษและเพลิดเพลินกับประสบการณ์ระดับพรีเมียม',
		yourVipBenefits: 'สิทธิประโยชน์ VIP ของคุณ',
		viewVipLevels: 'ดูระดับ VIP',
		exclusiveBenefitsTitle: 'สิทธิประโยชน์พิเศษของคุณ',
		tipExclusiveRewards: 'รางวัลพิเศษ',
		tipHigherRakeback: 'เงินคืนที่สูงขึ้น',
		tipPrioritySupport: 'บริการแบบเร่งด่วน',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'ระดับ',
		tableRequiredXp: 'EXP ที่ต้องใช้',
		tableLevelUpBonus: 'โบนัสเลื่อนระดับ',
		tableDailyRakeback: 'เงินคืนรายวัน',
		tableWeeklyLossback: 'เงินคืนจากยอดเสียรายสัปดาห์',
		signIn: 'เข้าสู่ระบบ',
		vipClubDefaultDesc: 'เข้าร่วม VIP Club ของเราตอนนี้ แล้วเตรียมรับของขวัญ ของแจก และฟีเจอร์สุดพิเศษมากมาย',
	},
};
